import "./AuthPage.scss";
import { useEffect } from "react";
import { useAppContext } from "../../Components/Context/AppContext";
import { getThemedAsset } from "../../helpers/themeAssets";

export const AuthPage = ({ children }) => {
  const { theme } = useAppContext();

  useEffect(() => {
    const authPageImage = getThemedAsset("authPageImage", theme);
    document.documentElement.style.setProperty(
      "--auth-page-image",
      `url(${authPageImage})`
    );
  }, [theme]);

  return <div className="auth-page-container">{children}</div>;
};
